/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ server: NonNullable<unknown> }} Audit_Details_Mcp_Server_Updated_DescInputs */



/**
* | output |
* | --- |
* | "The MCP server \"{server}\" was reconfigured." |
*
* @param {Audit_Details_Mcp_Server_Updated_DescInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const audit_details_mcp_server_updated_desc = /** @type {((inputs: Audit_Details_Mcp_Server_Updated_DescInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Audit_Details_Mcp_Server_Updated_DescInputs, { locale?: "en" | "de" }, {}>} */ ((i, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "de") return /** @type {LocalizedString} */ (`Der MCP-Server "${i?.server}" wurde neu konfiguriert.`)
	return /** @type {LocalizedString} */ (`The MCP server "${i?.server}" was reconfigured.`)
});